import React from 'react'
import './Hero.css'
import { Link } from 'react-router-dom'
 

const Hero = () => {
    return (
        <div className='hero' id='hero-navigate'>
            <div className='hero-text'>
                <h1 className='hero-h1'>We Make Amazing Haircuts</h1>
                <div className='hero-para-div'>
                    <p className='hero-para'>
                        The barbershop was opened in the 1970s. We the best in
                        cutting mens hair and shaving their beard. Let's see 
                        all our services below! Thanks for choose us!
                    </p>
                </div>
                <Link to='/appointment'>
                    <button className='hero-btn'>Book Now</button>
                </Link>
            </div>
        </div>
    )
}

export default Hero
